import 'angular:locale/data:fr-CA';
import 'angular:locale/data:en-CA';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
